import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './cambioDireccion.css';
import NavbarAdminMex from '../components/navbar';
import { utils, writeFile } from 'xlsx';
import { Modal } from 'antd';

const CambioDireccion = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [selectedPreenvio, setSelectedPreenvio] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    axios.get(`https://99envios.app/api/online/whatsapp/cambios-direccion`)
      .then(response => {
        const result = response.data && response.data.success && Array.isArray(response.data.data)
          ? response.data.data
          : [];
        setData(result);
      })
      .catch(error => console.error('Error fetching data: ', error));
  }, []);

  const handleSearch = (event) => {
    setSearch(event.target.value);
    setCurrentPage(1);
  };

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const sortedData = React.useMemo(() => {
    let sortableData = [...data];
    if (sortConfig.key !== '') {
      sortableData.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableData;
  }, [data, sortConfig]);

  const filteredData = sortedData.filter(item =>
    Object.values(item).some(value => 
      value && typeof value === 'string' && value.toLowerCase().includes(search.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);
  if (currentPage > totalPages && totalPages > 0) {
    setCurrentPage(totalPages);
  }

  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
  const currentEntries = filteredData.slice(indexOfFirstEntry, indexOfLastEntry);

  const paginationRange = () => {
    const totalNumbers = 5;
    const totalBlocks = totalNumbers + 2;
  
    if (totalPages > totalBlocks) {
      const startPage = Math.max(2, currentPage - 2);
      const endPage = Math.min(totalPages - 1, currentPage + 2);
      let pages = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  
      if (startPage > 2) {
        pages = ['...', ...pages];
      }
      if (endPage < totalPages - 1) {
        pages = [...pages, '...'];
      }
      return [1, ...pages, totalPages];
    }
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  };

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toISOString().split('T')[0];
  };

  const exportToExcel = () => {
    const exportData = filteredData.map(({ preenvio, ...item }) => item);
    const worksheet = utils.json_to_sheet(exportData);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Cambios_Direccion");
    writeFile(workbook, `Cambios_Direccion_${formatDateForDisplay(new Date())}.xlsx`);
  };

  const handleViewPreenvio = (preenvio) => {
    setSelectedPreenvio(preenvio);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedPreenvio(null);
  };

  return (
    <>
      <NavbarAdminMex title="Cambio de Dirección" />
      <div className="table-container-cambio-direccion-admin">
        <div className="table-controls">
          <div className="controls-group">
            <label htmlFor="entries">Mostrar</label>
            <select
              id="entries"
              name="entries"
              value={entriesPerPage}
              onChange={(e) => setEntriesPerPage(parseInt(e.target.value))}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>

            <input
              type="text"
              placeholder="Buscar"
              value={search}
              onChange={handleSearch}
              className="search-input"
            />
          </div>

          <div className="export-group">
            <button onClick={exportToExcel} className="export-button">Exportar a Excel</button>
          </div>
        </div>
        <table className="custom-table-cambio-direccion-admin">
          <thead>
            <tr>
              <th onClick={() => handleSort('numero_preenvio')}>Número Preenvío</th>
              <th onClick={() => handleSort('telefono_desinatario')}>Teléfono Destinatario</th>
              <th onClick={() => handleSort('ciudad')}>Ciudad</th>
              <th onClick={() => handleSort('direccion_antiguia')}>Dirección Antigua</th>
              <th onClick={() => handleSort('direccion_nueva')}>Dirección Nueva</th>
              <th onClick={() => handleSort('confirmacion_sucursal')}>Confirmación Sucursal</th>
              <th onClick={() => handleSort('id_estado')}>ID Estado</th>
              <th onClick={() => handleSort('nombre_estado')}>Estado</th>
              <th onClick={() => handleSort('created_at')}>Fecha Creación</th>
              <th onClick={() => handleSort('updated_at')}>Última Actualización</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {currentEntries.map((item, index) => (
              <tr key={index}>
                <td>{item.numero_preenvio}</td>
                <td>{item.telefono_desinatario}</td>
                <td>{item.ciudad}</td>
                <td>{item.direccion_antiguia}</td>
                <td>{item.direccion_nueva}</td>
                <td>{item.confirmacion_sucursal ? 'Sí' : 'No'}</td>
                <td>{item.preenvio?.id_estado}</td>
                <td>{item.preenvio?.nombre_estado}</td>
                <td>{formatDateForDisplay(item.created_at)}</td>
                <td>{formatDateForDisplay(item.updated_at)}</td>
                <td>
                  <button
                    onClick={() => handleViewPreenvio(item.preenvio)}
                    className="ver-info-button"
                  >
                    Información Preenvío
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="pagination-cambio-direccion-admin">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Anterior
          </button>
          {paginationRange().map((page, index) => (
            <button
              key={index}
              className={`page-button ${currentPage === page ? 'active' : ''}`}
              onClick={() => typeof page === 'number' && setCurrentPage(page)}
              disabled={typeof page !== 'number'}
            >
              {page}
            </button>
          ))}
          <button
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
          >
            Siguiente
          </button>
        </div>

        <Modal
          title="Información del Preenvío"
          open={isModalOpen}
          onCancel={handleModalClose}
          footer={null}
          width={800}
        >
          {selectedPreenvio && (
            <div className="preenvio-info">
              <h3>Información General</h3>
              <p><strong>Número Preenvío:</strong> {selectedPreenvio.numero_preenvio}</p>
              <p><strong>ID Estado:</strong> {selectedPreenvio.id_estado}</p>
              <p><strong>Estado:</strong> {selectedPreenvio.nombre_estado}</p>
              <p><strong>Fecha Creación:</strong> {formatDateForDisplay(selectedPreenvio.fecha_creacion)}</p>
              <p><strong>Fecha Vencimiento:</strong> {formatDateForDisplay(selectedPreenvio.fecha_vencimiento)}</p>
              
              <h3>Detalles del Envío</h3>
              <p><strong>Producto:</strong> {selectedPreenvio.nombre_producto}</p>
              <p><strong>Dice Contener:</strong> {selectedPreenvio.dice_contener}</p>
              <p><strong>Peso:</strong> {selectedPreenvio.peso} kg</p>
              <p><strong>Dimensiones:</strong> {selectedPreenvio.largo}x{selectedPreenvio.ancho}x{selectedPreenvio.alto} cm</p>
              
              <h3>Información de Costos</h3>
              <p><strong>Valor Flete:</strong> ${selectedPreenvio.valor_flete}</p>
              <p><strong>Valor Declarado:</strong> ${selectedPreenvio.valor_declarado}</p>
              <p><strong>Valor Servicio:</strong> ${selectedPreenvio.valor_servicio}</p>
              
              <h3>Observaciones</h3>
              <p>{selectedPreenvio.observaciones}</p>
            </div>
          )}
        </Modal>
      </div>
    </>
  );
};

export default CambioDireccion;